import React from "react";

export const Address = () => (
    <React.Fragment>
        7958 S Madison St <br/>
        Burr Ridge, IL 60565 <br/>
    </React.Fragment>
);
